'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var PropTypes = require('prop-types');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SplitBannerImage = function SplitBannerImage(props) {
  var imgUrl = props.imgUrl;
  var bannerImage = {
    backgroundImage: "url(".concat(imgUrl, ")")
  };
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: bannerImage,
    className: "lanl-splitbanner-image"
  });
};

SplitBannerImage.defaultProps = {};
SplitBannerImage.propTypes = {
  imgUrl: PropTypes__default['default'].string
};
exports.SplitBannerImage = SplitBannerImage;
exports['default'] = SplitBannerImage;